import Ajax from '../common/ajax'
import Tool from '../common/tool'

export default {
  model: 'common',
  getAppInfo () {
    return Ajax.get(`/api/gradeMaster/v1/organization/getHomeConfig`)
  },
  getNationality () {
    return Ajax.get(`/api/gradeMaster/v1/common/nationality`)
  },
  getListProvince () {
    return Ajax.get(`/api/gradeMaster/v1/common/listProvince`)
  },
  testAudio (text) {
    return Ajax.post(`/api/gradeMaster/v1/common/audio-text`, { text })
  },
  toPinyin (word) {
    return Ajax.post(`/api/gradeMaster/v1/common/toPinyin`, { word: word })
  },
  async getAreaTreeData (queryParam) {
    let list = await Ajax.get(`/api/gradeMaster/v1/common/listArea`)
    let treeData = Tool.toTree(list, 'areaId', 'parentId', '')
    return treeData
  },
  changeOfficePhoto (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/common/convertPhoto`, data)
  },
  exportExcelBf (data) {
    return Ajax.post(`/api/gradeMaster/v1/recordsAudit/export`, data)
  },
  changeAudit (data) {
    return Ajax.post(`/api/gradeMaster/v1/recordsAudit/audit`, data)
  },
  getRecordPage (data) {
    return Ajax.post(`/api/gradeMaster/v1/recordsAudit/page`, data)
  },
  getRecordDetail (auditId) {
    return Ajax.get(`/api/gradeMaster/v1/recordsAudit/detail/${auditId}`)
  }
}
